module.exports = __webpack_public_path__ + "img/er.d4ce2c38.png";